export default __webpack_public_path__ + "static/media/Theme-CVD-sim.561acc7b.png";